




















































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import companyApi from "@/api/companyApi";
import Company from "@/model/company";
import qNotify from "@/common/qNotify";
import store from "@/store";
import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import {DATE_FORMAT, DATE_FORMAT_JA, LICENSES} from "@/common/constant";
import {namespace} from "vuex-class";
import moment from "moment";

const authStore = namespace("Auth");

@Component({
  name: "PartnerDetail",
  computed: {
    isAllowLink: function() {
      return this.partner.is_allow_link === 1;
    },
  },
  components: {
    QCalendar,
    QErrors,
  },
})

export default class PartnerDetail extends Vue {
  @authStore.Getter
  public isAdmin;

  public isShow = false;
  public errors = {};
  public newPartner :Company = new Company();
  public partnerInit :Company = new Company();

  get partner() {
    return new Company(store.state.Company.mcCompany);
  }

  public async getPartnerInit() {
    this.partnerInit = new Company(store.state.Company.mcCompany);
  }

  public show() {
    this.isShow = true;
    this.errors = {};
    this.dateConfig = {};
    this.getPartnerInit();
  }

  public disableLink() {
    this.partner.is_allow_link = 0;
    this.updateIsAllowLink();
  }

  public enableLink() {
    this.partner.is_allow_link = 1;
    this.updateIsAllowLink();
  }

  public dateConfig: any = {
    disableMobile: "true",
    dateFormat: "Y-m-d",
  };

  @Watch('partner')
  async updateCalendar() {
    const licensesNumber = this.partner.licenses.length;
    this.partner.licenses.map((item, index) => {
      if (licensesNumber === index + 1) {
        this.dateConfig = {...this.dateConfig, ...{
          minDate: moment(item.applicable_date)
            .add(1, 'days')
            .format(DATE_FORMAT),
        }};
      }
    })
  }

  public async updateIsAllowLink() {
    await companyApi.updateIsAllowLink(this.partner);
    store.dispatch("Company/setCompany", this.partner);
  }

  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: this.$t("cancel"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.$emit('refreshMcList');
          this.isShow = false;
          this.errors = {};
          this.dateConfig = {};
          this.newPartner.company_licenses = [];
        },
        onClose: () => {
          console.log("onClose");
        },
      });
    } else {
      this.$emit('refreshMcList');
      this.isShow = false;
      this.errors = {};
      this.dateConfig = {};
      this.newPartner.company_licenses = [];
    }
  }

  public async edit() {
    this.partner.company_licenses = this.newPartner.company_licenses;
    const result = await companyApi.storeLicense(this.partner);
    if (result.meta.status != 200) {
      qNotify.error({
        text: this.$t("companies.updated_fail"),
      });
      this.errors = result.meta.errors;
    } else {
      qNotify.success({
        text: this.$t("companies.created"),
      });
      this.errors = {};
      this.dateConfig = {};
      this.newPartner.company_licenses = [];
      this.isShow = false;
      this.$emit('refreshMcList');
    }
  }

  public editCooperate(cooperateCompany, cooperateIndex) {
    store.dispatch("Company/setCompaniesCooperate", {
      ...cooperateCompany.pivot,
      ... {cooperate_company_name : cooperateCompany.name}
    });
    this.$emit('editCooperate', cooperateIndex);
  }

  public deleteCooperate(cooperateCompany, index) {
    this.$modal.showDelete({
      text: this.$t("deleteCooperate", { company_name: cooperateCompany.name }),
      confirmText: this.$t("confirm_text.yes"),
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        const result = await companyApi.deleteCooperate(cooperateCompany.pivot.id);
        if (result.meta.status === 200) {
          qNotify.success({
            text: this.$t("companies.cooperate_deleted"),
          });
          store.dispatch("Company/spliceCooperate", index);
          this.errors = {};
          this.dateConfig = {};
        } else {
          qNotify.error({
            text: this.$t(result.meta.message),
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public deleteCompany(companyId) {
    this.$modal.showDelete({
      text: this.$t("delete"),
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        const result = await companyApi.deleteCompany(companyId);
        if (result.status === 200) {
          this.isShow = false;
          this.$emit('refreshMcList');
          qNotify.success({
            text: this.$t("companies.deleted"),
          });
          this.errors = {};
          this.dateConfig = {};
        } else {
          qNotify.error({
            text: result.data.message,
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public cooperatePartner() {
    store.dispatch("Company/setMcCompanyId", this.partner.id);
    this.$emit('createCooperate');
  }

  public createPartner() {
    store.dispatch("Company/setMcCompanyId", this.partner.id);
    this.$emit('createPartner');
  }

  get getLicenses() {
    return LICENSES;
  }

  public getApplicableDateFormatJA (applicable_date) {
    return moment(applicable_date).format(DATE_FORMAT_JA)
  }

  public isChanged() {
    return  !(this.partner.companies_cooperate.length === this.partnerInit.cooperate_count
      && this.newPartner.company_licenses.length === 0
    )
  }
}
